<template>
  <div class="favorite-list l-container">
    <!-- Favorite-list header -->
    <div class="flex flex-wrap">
      <div class="w-full">
        <h1>お気に入りリスト</h1>
      </div>
    </div>
    <!-- Favorite-list header -->

    <div class="divider"></div>
    <!-- Favorite-list container -->
    <div class="favorite-list l-container">
      <div class="favorite-list-wrapper">
        <!-- Sidebar -->
        <div class="left-content">
          <LeftMenuBar :navBars="navBars" />
        </div>

        <div class="base-content">
          <!-- Tabs-card -->
          <a-card class="base-content-top">
            <a-tabs default-active-key="1">
              <!-- Fav-list -->
              <a-tab-pane name="fav-list" tab="お気に入りメニュー" key="1">
                <!-- Button-action -->
                <div class="button btn-sm">
                  <div class="button-modify">
                    <a-button class="b-button">リスト編集 </a-button>
                  </div>
                  <div class="button-filter">
                    <a-button class="b-button"  @click="changeSortBy()">
                      <i class="icon icon-bor-arrow-2-way mr-1"></i>
                      <span class="normal-case sm:hidden" v-if="isSortAsc">
                        閲覧日時の新しい順
                      </span>
                      <span class="normal-case sm:hidden" v-if="!isSortAsc">
                        閲覧日時の古い順
                      </span>
                      <span class="small-case hidden sm:inline-flex">
                        閲覧日時降順
                      </span>
                    </a-button>
                    <a-button class="b-button">
                      <i class="icon icon-bor-filter mr-1"></i>
                      <span class="normal-case sm:hidden">
                        カテゴリで絞り込む
                      </span>
                      <span class="small-case hidden sm:inline-flex">
                        絞り込み
                      </span>
                    </a-button>
                  </div>
                </div>
                <!-- Pagination -->
                <div class="pagination">
                  <div class="w-1/4 sm:w-full flex items-center">
                    <p class="total"><strong>{{ totalResults }}</strong>件中
                    <span v-if="page === 1 && totalResults"> 1～ </span>
                    <span v-if="!totalResults">0</span>
                    <span v-if="page > 1"> {{ (page -1) * 10 + 1 }}</span>
                    <span v-if="page > 1">～</span>
                    <span v-if="totalResults <= 10"> {{ totalResults }} </span>
                    <span v-if="totalResults > 10 && ((page - 1) * 10 < Math.floor(totalResults/10)*10) "> {{ page * 10 }}</span>
                    <span v-if="totalResults > 10 && ((page - 1) * 10 >= Math.floor(totalResults/10)*10 && (page - 1) * 10 < totalResults) "> {{ (page -1) * 10 + totalResults % 10}}</span>
                    件
                    </p>
                  </div>
                  <Pagination
                    class="w-2/4 sm:w-full flex justify-center sm:hidden"
                    @onChange="onChange"
                    :page="page"
                    :pageCount="5"
                    :pageSlot="5"
                    :totalRecord="totalResults"
                  />
                </div>
              </a-tab-pane>

              <!-- My-list -->
              <a-tab-pane name="my-list" tab="マイリスト" v-if="hidden" key="2">
                <!-- Button -->
                <div class="button btn-sm">
                  <div class="button-modify">
                    <a-button class="b-button">リスト編集 </a-button>
                  </div>
                  <div class="button-filter">
                    <a-button class="b-button" @click="changeSortBy()">
                      <i class="icon icon-bor-arrow-2-way mr-1"></i>
                      <span class="normal-case sm:hidden" v-if="isSortAsc">
                        閲覧日時の新しい順
                      </span>
                      <span class="normal-case sm:hidden" v-if="!isSortAsc">
                        閲覧日時降順
                      </span>
                    </a-button>
                    <a-button class="b-button">
                      <i class="icon icon-bor-filter mr-1"></i>
                      <span class="normal-case sm:hidden">
                        カテゴリで絞り込む
                      </span>
                      <span class="small-case hidden sm:inline-flex">
                        絞り込み
                      </span>
                    </a-button>
                  </div>
                </div>
                <!-- Pagination -->
                <div class="pagination">
                  <div class="w-1/4 sm:w-full flex items-center">
                    <p class="total"><strong>{{ totalResults }}</strong>件中 
                    <span v-if="page === 1 && totalResults"> 1～ </span>
                    <span v-if="!totalResults">0</span>
                    <span v-if="page > 1"> {{ (page -1) * 10 + 1 }}</span>
                    <span v-if="page > 1">～</span>
                    <span v-if="totalResults <= 10"> {{ totalResults }} </span>
                    <span v-if="totalResults > 10 && ((page - 1) * 10 < Math.floor(totalResults/10)*10) "> {{ page * 10 }}</span>
                    <span v-if="totalResults > 10 && ((page - 1) * 10 >= Math.floor(totalResults/10)*10 && (page - 1) * 10 < totalResults) "> {{ (page -1) * 10 + totalResults % 10}}</span>
                    件
                    </p>
                  </div>
                  <Pagination
                    class="w-2/4 sm:w-full flex justify-center sm:hidden"
                     @onChange="onChange"
                    :page="page"
                    :pageCount="5"
                    :pageSlot="5"
                    :totalRecord="totalResults"
                  />
                </div>
              </a-tab-pane>
            </a-tabs>
          </a-card>
          <!-- Tabs-card -->

          <!-- Items-card -->
          <a-card
            class="base-content-item"
            v-for="(item, index) in favoriteList"
            :key="index"
          >
            <div class="flex">
              <div class="float-left">
                  <div v-if="item.imageUrl" class="img-item show-img" :style="{'background-image': `url(${item.imageUrl})`}"> </div>
                  <div class="img-item show-img-1" v-if="!item.imageUrl"></div>
              </div>

              <div class="base-content-item-detail">
              <div class="top">
                <div class="label label-grey-200" v-show="item.catNm">{{ item.catNm }}</div>
                <div class="item-number" v-show="item.menuNo">メニューNo. {{ item.menuNo }}</div>
              </div>
              <div class="title two-lines-ellipsis" @click="gotoPath(item.menuNo)">
                <a class="text-black">{{ item.menuNm }}</a>
              </div>
              <div class="address">
                <span v-if="getAreaClassNm(item)" class="icon icon-bor-pin"></span>
                <span class="address-text pl-2">{{getAreaClassNm(item)}}</span>
              </div>
              <div class="delete-item">
                <a @click="showModalDelete(item.id)">
                  <img class="icon-trash"
                    src="@/assets/images/Symbols_2.png"
                    alt=""/>
                  <span class="address-text hover:pl-2"> 削除 </span>
                </a>
              </div>
            </div>
            </div>
            <div class="delete-item-sm">
              <a @click="showModalDelete(item.id)">
              <img class="icon-trash"
                src="@/assets/images/Symbols_2.png"
                alt=""/>
              <span class="address-text hover:pl-2"> 削除 </span>
              </a>
            </div>

          </a-card>

          <a-card v-if="favoriteList.length === 0">
             <a-empty />
            <div class="text-center"> 
              <span>{{ descriptionImageBlank }}</span>
            </div>
          </a-card>
          <!-- Items-card -->

  
          <!-- Pagination-bottom -->
          <a-card class="pt-5 base-content-bottom">
            <div class="pagination">
              <div class="text-bottom w-1/4 sm:w-full flex items-center">
                <p class="total"><strong>{{ totalResults }}</strong>件中 
                    <span v-if="page === 1 && totalResults"> 1～ </span>
                    <span v-if="!totalResults">0</span>
                    <span v-if="page > 1"> {{ (page -1) * 10 + 1 }}</span>
                     <span v-if="page > 1">～</span>
                    <span v-if="totalResults <= 10"> {{ totalResults }} </span>
                    <span v-if="totalResults > 10 && ((page - 1) * 10 < Math.floor(totalResults/10)*10) "> {{ page * 10 }}</span>
                    <span v-if="totalResults > 10 && ((page - 1) * 10 >= Math.floor(totalResults/10)*10 && (page - 1) * 10 < totalResults) "> {{ (page -1) * 10 + totalResults % 10}}</span>
                    件
                </p>
              </div>
              <Pagination
                class="w-2/4 sm:w-full flex justify-center"
                :page="page"
                :pageCount="5"
                :pageSlot="5"
                :totalRecord="totalResults"
              />
            </div>
          </a-card>

          <!-- Pagination-bottom -->
        </div>
      </div>
    </div>
    <!-- Favorite-list container -->
    <!-- Popup remove favorite -->
    <div>
      <a-modal title="" ok-text="削除" 
        cancel-text="キャンセル"
        :visible="visiblePopupDelete"
        @ok="handleOk"
        @cancel="handleCancel">
        <p>お気に入り一覧に削除してよろしいでしょうか？</p>
      </a-modal>
    </div>
    
  </div>
</template>

<script>
import { LeftMenuBar } from '@/components/compound'
import { GET_FAVORITE_LIST, DELETE_FAVORITE } from '@/store/modules/bs_myp/actions'
import _ from 'lodash'

export default {
  name: 'BS_MYP_04_001',
  components: {
    LeftMenuBar
  },
  data() {
    return {
      totalResults: null,
      visiblePopupDelete: false,
      visiblePopupLogout: false,
      itemDelete: null,
      isSort: true,
      isSortAsc: true,
      page: 1,
      hidden: false,
      numberStartPage: '',
      numberEndPage: '',
      catLrgClassNm: '',
      catMidClassNm: '',
      catSmlClassNm: '',
      latitude: null,
      longitude: null,
      descriptionImageBlank: 'お気に入りに登録された商品はありません。',
      favoriteList: [],
      params: {
        itemType: 'favourite',
        page: 0, 
        size: 10,
        sort: 'dateAdded,desc'
      },
      navBars: [
        { path: '/mypage', name: 'マイページトップ' },
        { type: 'divider' },
        { path: '/mypage/benepo-history', name: '総保有ベネポ・ベネポ履歴' },
        { path: '/mypage/benepo-collect', name: '獲得予定のベネポ' },
        { type: 'divider' },
        { path: '/mypage/coupons', name: '専用ポイント・補助クーポン' },
        { type: 'divider' },
        { path: 'bs-myp-02-001', name: 'マイクーポン' },
        { path: 'bs-myp-02-010', name: '過去のクーポン' },
        { type: 'divider' },
        { path: '/mypage/orders', name: 'お申し込み履歴' },
        { path: '', name: '給トク払いご利用履歴', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '/mypage/visits', name: '閲覧履歴' },
        { type: 'divider' },
        { path: '#', name: 'お気に入りメニュー' },
        { type: 'divider' },
        { path: '/mypage/setting', name: '会員プロフィール', icon: 'icon-bor-copy' },
        { path: '', name: 'メール受信・通知', icon: 'icon-bor-copy' },
        { path: '', name: 'クレジットカード', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: '家族アカウント管理', icon: 'icon-bor-copy' }
      ]
    }
  },
  mounted() {
    if (this.loggedIn) {
      this.getFavoriteList(this.params)
      this.hidden = this.responsiveDisplayValue
    } else {
      const params = {
        loggin: 1
      }
      this.$router.push({path: '/', query: params})
    }
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    }
  },
  methods: {
    getAreaClassNm(item) {
      return _.get(item, 'areaMidClassNm', '') + _.get(item, 'areaDtlClassNm', '')
    },
    getFavoriteList(params) {
      params.page = this.page - 1
      if (params.page === -1) {
        this.params.page = 0
      }
      this.$store.dispatch(GET_FAVORITE_LIST, params).then((data) => {
        if(data !== null) {
          this.favoriteList = []
          this.totalResults = _.get(data, 'totalElements', '')
          // const dataFavorites = []
          // console.log(_.get(data, 'content[0].id', ''))
          // data.content.forEach(item => {
          //   const favorite = JSON.parse(item.menuDetailResponse)
          //   dataFavorites.push(favorite)
          // })
          data.content.map(item => {
            return {
              id: item.id,
              ...JSON.parse(item.menuDetailResponse)
            }
          }).forEach(content => {
            const favorite = {}
            favorite.id = content.id
            favorite.imageUrl = _.get(content, 'menuImages[0].imageUrl', '')
            favorite.menuNo = _.get(content, 'menuNo', '')
            favorite.catNm = this.getCatNm(_.get(content, 'categoryInfomation', ''))
            favorite.menuNm = _.get(content, 'menuNm', '')
            favorite.areaMidClassNm = _.get(content, 'areaInfomation.areaMidClassNm', '')
            favorite.areaDtlClassNm = _.get(content, 'areaInfomation.areaDtlClassNm', '')
            favorite.latitude = _.get(content, 'areaInfomation.latitude', '')
            favorite.longitude = _.get(content, 'areaInfomation.longitude', '') 
            this.favoriteList.push(favorite)
          })

        }
      })
    },
    deleteFavoriteInList(id) {
      this.$store.dispatch(DELETE_FAVORITE, id).then(
        () => {
          this.getFavoriteList(this.params)
          
          this.visiblePopupDelete = false
          this.$toasted.success('情報が削除されました。')
        },
        (err) => {
          const error = err.error
          this.$toasted.error(error && error.message ? error.message : error)
        }
      )
    },
    onChange(page) {
      this.page = page
      this.getFavoriteList(this.params)
    },
    changeSortBy() {
      this.isSortAsc = !this.isSortAsc
      if(this.isSort) {
        this.params.sort = 'dateAdded,asc'
        this.getFavoriteList(this.params)
        this.isSort = false
        return
      }
      this.params.sort = 'dateAdded,desc'
      this.getFavoriteList(this.params)
      this.isSort = true
    },
    showModalDelete($event) {
      this.itemDelete = $event
      this.visiblePopupDelete = true
    },
    handleOk() {
      this.deleteFavoriteInList(this.itemDelete)
    },
    handleCancel() {
      this.visiblePopupDelete = false
    },
    responsiveDisplayValue: () => {
      return document.body.scrollWidth < 639
    },
    getCatNm(categoryInfomation) {
      let catNm = ''
      this.catLrgClassNm = _.get(categoryInfomation, 'catLrgClassNm', '')
      this.catMidClassNm = _.get(categoryInfomation, 'catMidClassNm', '')
      this.catSmlClassNm = _.get(categoryInfomation, 'catSmlClassNm', '')
      if(this.catLrgClassNm === '' && this.catMidClassNm === '' && this.catSmlClassNm !== '') {
        catNm = `${this.catSmlClassNm}`
      }
      if(this.catLrgClassNm === '' && this.catMidClassNm !== '' && this.catSmlClassNm === '') {
        catNm = `${ this.catMidClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm === '' && this.catSmlClassNm !== '') {
        catNm = `${ this.catLrgClassNm}`
      }
      if(this.catLrgClassNm === '' && this.catMidClassNm !== '' && this.catSmlClassNm !== '') {
        catNm = `${this.catMidClassNm  }・${ this.catSmlClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm === '' && this.catSmlClassNm !== '') {
        catNm = `${this.catLrgClassNm  }・${ this.catSmlClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm !== '' && this.catSmlClassNm === '') {
        catNm = `${this.catLrgClassNm  }・${ this.catMidClassNm}`
      }
      if(this.catLrgClassNm !== '' && this.catMidClassNm !== '' && this.catSmlClassNm !== '') {
        catNm = `${this.catLrgClassNm  }・${  this.catMidClassNm  }・${ this.catSmlClassNm}`
      }
      return catNm
    },
    gotoPath(menuNo) {
      this.$router.push(`/menus/${menuNo}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
